import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { UserService } from '@app/shared/services/user.service';
import { map } from 'rxjs';

export const dataImportGuard: CanActivateFn = () => {
  const userService = inject(UserService);
  const router = inject(Router);

  return userService.fetchUser$.pipe(
    map((user) => {
      const hasImportAccess = user.access.deregistrations || user.access.verifiedTransport;

      return (user.userType === 'FLEET_OWNER' && hasImportAccess) || router.parseUrl('');
    })
  );
};
